<!-- <div class="container">
    <app-container-header></app-container-header>
    <router-outlet></router-outlet>
</div> -->

<div class="flex" [style.background]="getFondo()" >
    <app-container-header></app-container-header>
    <div class="w-full mx-2" >
        <router-outlet class="bg-white  dark:bg-gray-800"></router-outlet>
    </div>
</div>
